<template>
	<div id="app">
		
		<pm-loader></pm-loader>
		<router-view />
	</div>
</template>

<script>
	import PmLoader from "@/components/clientes/Loader"
	// import LottieAnimation from "@/components/lottieAnimation"

	export default {
		components: {
			// LottieAnimation,
			PmLoader,
		},
		mounted() {
			const loadingElement = document.getElementById('loading');
			const appElement = document.getElementById('app');

			if (loadingElement) {
			loadingElement.style.display = 'none';
			}
			
			if (appElement) {
				appElement.style.display = 'block';
			}
		}
	}
</script>

<style lang="scss">
</style>
